import { useDispatch } from "react-redux";

import { setSection } from "../../../assignmentSlice";

import { typeInfo } from "../../../../../constants/typeInfo";

import UserInputBar from "../../widgets/UserInputBar";

const SubjectiveExamPage = ({
  currentPage,
  userInput,
  setUserInput,
  handleSubmit,
}) => {
  const handleChange = (e) => {
    setUserInput(e.target.value);
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        width: "75vw",
        gap: "30px",
      }}
    >
      <div
        style={{
          fontSize: "20px",
          color: "#737373",
          textAlign: "center",
        }}
      >
        {currentPage.question}
      </div>
      {currentPage.type === "example_blank" && (
        <div
          style={{
            fontSize: "28px",
            textAlign: "center",
          }}
        >
          {currentPage.text1}
        </div>
      )}
      <div
        style={{
          fontSize: "28px",
          textAlign: "center",
        }}
      >
        {currentPage.text}
      </div>
      <div style={{ position: "relative", width: "60%", marginTop: "50px" }}>
        <UserInputBar
          handleChange={handleChange}
          userInput={userInput}
          type="vocabulary"
          disabled={currentPage.isSubmitted}
          handleSetAnswer={handleSubmit}
        />
      </div>
    </div>
  );
};

export default SubjectiveExamPage;
